/*
 * @Description: Do not edit
 * @Author: 文件创建人：任亮
 * @Date: 2022-10-25 14:39:16
 * @LastEditors: 文件最后更新人：任亮
 * @LastEditTime: 2026-03-05 17:29:13
 */
import { Post, TResult, Get } from "../../request";
import { rasEncrypt } from "@utils";
import { getLocalData } from "@utils";
import qs from 'qs'
import useStore from "@/config/pinia";
import request from '@/config/api/request'
/**
 * 登陆
 * @param options
 */
export const loginApi = (params: any): TResult<any> => {
  return Post('/oauth/token', { params, isAuth: true })
}

/**
 * 用户登出
 */
export const loginOutApi = (): TResult<any> => {
  return Get('/oauth/revokeToken')
}

/**
 * 发送验证码
 * http://api-center-bigdata.huan.tv/project/681/interface/api/13886
 */
export const SendCaptchaCodeApi = (email: string): TResult<any> => {
  return Get(`/user/sendCode?email=${email}`, { isToken: false })
}
/**
 * 重置密码
 * http://api-center-bigdata.huan.tv/project/681/interface/api/13871
 */
export const ChangePasswordApi = (params: any): TResult<any> => {
  return Post('/user/updatePasswordByCode', { params, isToken: false })
}

/**
 * 详细
 * @param options
 */
export const getUserInfoApi = (): TResult<any> => {
  return Get('/oauth/info')
}

// 获取所有权限集合
export const getSysMenuListApi = (): TResult<any> => {
  return Get(`/sysMenu/list`);
};

// 保存或者修改自定义列头
export const updateColumnsApi = (params: any): TResult<any> => {
  return Post(`/custom/save`, { params });
};
// 自定义列查询
export const getColumnsInfoApi = (params: any): TResult<any> => {
  return Get(`/custom/find`, { params });
};

/**
 * 字典查询
 * @params AD_SOURCE-广告来源字典库 ; APP_PACKET-应用包名 DSP - dsp ；
 * SUPERVISE_COMPANY：监测公司
 */
export const getSysDictListApi = (params: any): TResult<any> => {
  return Get("/sys-dict", { params });
};
// 查询字典ids
export const getSysDictIdsListApi = (params: any): TResult<any> => {
  return Post("/sys-dict/ids", { params });
};
// 根据token 获取区域列表
export const getParentRegionListApi = (params: any): TResult<any> => {
  return Get("/region/parentListByUser", { params });
};

// 广告主列表
export const getAdvertiserListApi = (): TResult<any> => {
  return Get("/advertiser/list");
};
// 原始项目列表
export const getSubjectAppendListApi = (params: any): TResult<any> => {
  return Post("/subject/subject-append-list", { params });
};

// 文件上传
export const uploadFileApi = (params: any): TResult<any> => {
  return Post("/upload/file", { params, isForm: true });
};
// 文件批量上传
export const uploadFileBatchApi = (params: any, isForm: boolean = false): TResult<any> => {
  return Post("/upload/file/batch", { params, isForm });
};
// 邮件批量上传
export const uploadFileEmailBatchApi = (params: any, isForm: boolean = false): TResult<any> => {
  // return Post("/upload/file/batch",{ params, isForm });
  const store = useStore();
  const users = store.tokenData
  var headers: any = ''
  if (users && users['access_token']) {
    headers = {
      Authorization: `bearer ${getLocalData('token-data').access_token}`,
    }
  }
  return request.post(`/upload/file/batch`, params, {
    headers: headers,
    timeout: 5 * 60 * 1000
  })
};

/**
 * 改单记录列表
 * http://api-center-bigdata.huan.tv/project/681/interface/api/13941
 * @param options
 */
export const GetSubjectTaskPageApi = (params: any): TResult<any> => {
  return Get(`/update-log/page?${qs.stringify(params)}`)
}
/**
 * 改单记录详情
 * http://api-center-bigdata.huan.tv/project/681/interface/api/13941
 * @param options
 */
export const GetSubjectTaskInfoApi = (params: any): TResult<any> => {
  return Get(`/update-log/info?${qs.stringify(params)}`)
}